import React from 'react'
import _ from 'lodash/fp'
import {CardHeader, Card, BrandFooter} from '../../components/SigninLayout'
import styled, {css} from 'styled-components'
import {Button, Icon} from '@startlibs/components'
import {getColor, callIfFunction} from '@startlibs/utils'
import {LoadingErrorDialog} from '../LoadingErrorDialog'

import {getSupportMail, getSupportPhone} from '../../utils/contactDefaults'

const ErrorPageLayout = styled.div`
  color: rgba(0,0,0,0.5);
  min-height: 100%;
  @supports (flex-wrap: wrap) {
    display: flex;
    align-items: center;
  }
  h1 {
    margin-bottom: 0.5rem;
    font-size: 22px;
  }
  a {
    color: ${getColor('main')};
    font-weight: 600;
  }
`

export class ProviderErrorBoundary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError(error) {
    const status = _.get([1,'status'],callIfFunction(error && error.get))
    // Update state so the next render will show the fallback UI.
    return {hasError: true, expired: status  === 410 || status  === 470, status}
  }

  closeDialog = () => {
    this.setState({closingDialog:true})
    setTimeout(() => window.parent.postMessage(JSON.stringify({type: 'removeIframe'}), '*'), 300)
  }

  render() {
    const email = getSupportMail()
    const phone = getSupportPhone()

    if (this.state.hasError) {
      if (this.props.isDialog) {
        return (this.state.closingDialog ? null : <LoadingErrorDialog errorCode="03" closeDialog={this.closeDialog}/>)
      } else if (this.state.expired) {
        if (this.state.status === 470) {
          return <ErrorPageLayout withoutLogo>
            <Card>
              <CardHeader>
                <h1>This link has expired.</h1>
              </CardHeader>
              <p>Please contact the provider who shared the link with you and ask them to
                reshare your study or reach out to us for assistance
                at <a href={`mailto:${email}`} target="_blank">{email}</a></p>
            </Card>
          </ErrorPageLayout>
        } else {
          return <ErrorPageLayout withoutLogo>
            <Card>
              <CardHeader>
                <h1>This study is no longer available.</h1>
              </CardHeader>
              <p>The shared study link you are accessing has expired and you are no longer able to access it.</p>
              <p>In case you need to be granted access again, please reach out to the person
                who shared this study in order to have it shared again.</p>
            </Card>
          </ErrorPageLayout>
        }
      } else {
        return <ErrorPageLayout withoutLogo>
          <Card>
            <CardHeader>
              <h1>Something went wrong</h1>
            </CardHeader>
            <p><b>Please reload the page and try again.</b></p>
            <p>If the error persists please contact <a href={`mailto:${email}`}
                                                       target="_blank">{email}</a> or <span
              className="nowrap">call <b>{phone}</b>.</span></p>
          </Card>
        </ErrorPageLayout>
      }
    }
    return this.props.children
  }
}